<template>
  <div>
    <v-row class="subtitle-2 pl-3 font-weight-bold" style="color: #4F4F4F">Active Seat Change Requests:</v-row>
    <v-data-table :items="seatManagementPendingRequests" :headers="headers" hide-default-footer dense>
      <template v-slot:item.quantity="{ item }">
        <span v-if="item.quantity > 0" style="color: #8AC24A">Add</span>
        <span v-else style="color: #E61E50">Remove</span>
      </template>
      <template v-slot:item.name="{ item }">
        <div>{{ item.firstName }} {{ item.lastName }}</div>
      </template>
      <template v-slot:item.status="{ item }">
        <div v-if="item.status === 'InProcess'">In Process</div>
        <div v-else-if="item.status === 'Available'" class="link" @click="editUser(item.id)">Pending</div>
        <div v-else>{{ item.status }}</div>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-btn v-if="item.status === 'Available'" icon @click="item.quantity > 0 ? editUser(item.id) : deleteUser(item.id)"><v-icon color="#2DBECD">edit</v-icon></v-btn>
      </template>
    </v-data-table>
    <RemoteAgencyPendingUserEditDialog v-if="showEditUserDialogFlag" :id="id" :show-edit-user-dialog="showEditUserDialogFlag" @close="showEditUserDialogFlag = false"></RemoteAgencyPendingUserEditDialog>
    <RemoteAgencyPendingUserDeleteDialog v-if="showDeleteUserDialogFlag" :id="id" :show-delete-user-dialog="showDeleteUserDialogFlag" @close="showDeleteUserDialogFlag = false"></RemoteAgencyPendingUserDeleteDialog>
  </div>
</template>

<script>
import RemoteAgencyPendingUserEditDialog from './RemoteAgencyPendingUserEditDialog';
import RemoteAgencyPendingUserDeleteDialog from './RemoteAgencyPendingUserDeleteDialog';
import { mapState } from 'vuex';

export default {
  name: 'PendingSeatChangeRequests',
  components: {
    RemoteAgencyPendingUserEditDialog,
    RemoteAgencyPendingUserDeleteDialog
  },
  props: {
    agencySeatRequests: {
      type: Array,
      required: true
    },
    headers: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      panelFlag: [0],
      showEditUserDialogFlag: false,
      showDeleteUserDialogFlag: false,
      id: null
    };
  },
  computed: {
    ...mapState(['seatManagementPendingRequests'])
  },
  methods: {
    editUser (id) {
      this.id = id;
      this.showEditUserDialogFlag = true;
    },
    deleteUser (id) {
      this.id = id;
      this.showDeleteUserDialogFlag = true;
    }
  }
};
</script>

<style>
  .link {
    color: #2DBECD
  }

</style>
